import { Typography } from '@mui/material';

export default function ForwardedContent() {
  return (
    <Typography
      sx={{
        cursor: 'pointer', fontSize: '12px', p: 1, fontWeight: 'bold', fontStyle: 'normal', color: '#3390ec',
      }}
      component="span"
    >
      محتوای باز ارسال شده
    </Typography>
  );
}
